module.exports = "/_next/static/images/teacher-6-02820013f0f5c51ca0fcff123d2a7044.png";